export const SpecialOfferTracks = {
  /** 中文特惠-点击购买1个月套餐 */
  CNPlan_Buy1M_Click: 'CNPlan_Buy1M_Click',
  /** 中文特惠-点击购买3个月套餐 */
  CNPlan_Buy3M_Click: 'CNPlan_Buy3M_Click',
  /** 中文特惠-点击购买12个月套餐 */
  CNPlan_Buy12M_Click: 'CNPlan_Buy12M_Click',
  /** 中文特惠-首次订阅成功-弹窗展示 */
  CNPlan_FirstSuccess_Show: 'CNPlan_FirstSuccess_Show',
  /** 中文特惠-首次订阅成功-弹窗关闭 */
  CNPlan_FirstSuccess_Hide: 'CNPlan_FirstSuccess_Hide',
  /** 中文特惠-非首次订阅成功-弹窗展示 */
  CNPlan_ReturnSuccess_Show: 'CNPlan_ReturnSuccess_Show',
  /** 中文特惠-非首次订阅成功-弹窗关闭 */
  CNPlan_ReturnSuccess_Hide: 'CNPlan_ReturnSuccess_Hide',
  /** 中文特惠-订阅成功-点击立即激活积分入口 */
  CNPlan_Activate_Click: 'CNPlan_Activate_Click',
  /** 中文特惠-订阅成功-联系客服激活积分弹窗展示 */
  CNPlan_ServiceModal_Show: 'CNPlan_ServiceModal_Show',
  /** 中文特惠-订阅成功-联系客服激活积分弹窗关闭 */
  CNPlan_ServiceModal_Hide: 'CNPlan_ServiceModal_Hide',
  /** 中文特惠版升级标准版-报错弹窗展示 */
  CNPlan_ErrToStd_Show: 'CNPlan_ErrToStd_Show',
  /** 中文特惠版升级标准版-报错弹窗关闭 */
  CNPlan_ErrToStd_Hide: 'CNPlan_ErrToStd_Hide',
  /** 标准版升级中文特惠版-报错弹窗展示 */
  CNPPlan_ErrToCN_Show: 'CNPPlan_ErrToCN_Show',
  /** 标准版升级中文特惠版-报错弹窗关闭 */
  CNPlan_ErrToCN_Hide: 'CNPlan_ErrToCN_Hide',
  /** 中文特惠Plan页展开QA-使用LeadContact，会不会导致我的领英账号被封？ */
  CNPlan_QA_Safety_Click: 'CNPlan_QA_Safety_Click',
  /** 中文特惠Plan页展开QA-在领英上查找联系方式，需要加好友吗？ */
  CNPlan_QA_NoConnect_Click: 'CNPlan_QA_NoConnect_Click',
  /** 中文特惠Plan页展开QA-一个账号可以多人共用吗？ */
  CNPlan_QA_MultiUser_Click: 'CNPlan_QA_MultiUser_Click',
  /** 中文特惠Plan页展开QA-我可以通过哪些方式支付？ */
  CNPlan_QA_Payment_Click: 'CNPlan_QA_Payment_Click',
  /** 中文特惠Plan页展开QA-会自动扣费吗？ */
  CNPlan_QA_AutoPay_Click: 'CNPlan_QA_AutoPay_Click',
  /** 中文特惠Plan页展开QA-购买后可以开具发票吗？ */
  CNPlan_QA_Invoice_Click: 'CNPlan_QA_Invoice_Click',
  /** 中文特惠Plan页展开QA-我有更多问题。 */
  CNPlan_QA_More_Click: 'CNPlan_QA_More_Click',
  /** 中文特惠Plan页QA点击联系Julia邮箱（我可以通过哪些方式支付？） */
  CNPlan_QA_MailPay_Click: 'CNPlan_QA_MailPay_Click',
  /** 中文特惠Plan页QA点击联系Julia邮箱（我有更多问题。） */
  CNPlan_QA_MailMore_Click: 'CNPlan_QA_MailMore_Click',
  /** 中文特惠-Team版-点击联系客服 */
  CNPlan_BuyTeam_ContactSales_Click: 'CNPlan_BuyTeam_ContactSales_Click',
  /** 中文特惠-Team版-打开联系客服弹窗 */
  CNPlan_BuyTeam_ContactSales_Popup_Show:
    'CNPlan_BuyTeam_ContactSales_Popup_Show',
  /** 中文特惠-Team版-联系客服弹窗-点击添加WhatsApp */
  CNPlan_BuyTeam_ContactSales_Whatsapp_Click:
    'CNPlan_BuyTeam_ContactSales_Whatsapp_Click',
  /** 中文特惠-Team版-联系客服弹窗-点击添加微信 */
  CNPlan_BuyTeam_ContactSales_Wechat_Click:
    'CNPlan_BuyTeam_ContactSales_Wechat_Click',
  /** 中文特惠-Team版-联系客服弹窗-点击打开本地邮箱 */
  CNPlan_BuyTeam_ContactSales_Email_Open_Click:
    'CNPlan_BuyTeam_ContactSales_Email_Open_Click',
  /** 中文特惠-Team版-联系客服弹窗-点击复制邮箱 */
  CNPlan_BuyTeam_ContactSales_Email_Copy_Click:
    'CNPlan_BuyTeam_ContactSales_Email_Copy_Click',
  /** 中文特惠-Team版-联系客服弹窗-点击打开Facebook */
  CNPlan_BuyTeam_ContactSales_Facebook_Click:
    'CNPlan_BuyTeam_ContactSales_Facebook_Click',
  /** 中文特惠-Team版-联系客服弹窗-关闭 */
  CNPlan_BuyTeam_ContactSales_Close_Hide:
    'CNPlan_BuyTeam_ContactSales_Close_Hide',
  /** 中文特惠-点击分享返现入口 */
  CNPlan_ShareRewardEntryClick: 'CNPlan_ShareRewardEntryClick',
  /** 中文特惠-展示分享返现弹窗 */
  CNPlan_ShareRewardModalShow: 'CNPlan_ShareRewardModalShow',
  /** 中文特惠-关闭分享返现弹窗 */
  CNPlan_ShareRewardModalHide: 'CNPlan_ShareRewardModalHide',
  /** 中文特惠-分享返现弹窗-复制文案和链接 */
  CNPlan_ShareRewardCopyClick: 'CNPlan_ShareRewardCopyClick',
  /** 中文特惠-分享返现弹窗-点击添加微信 */
  CNPlan_ShareRewardWechatClick: 'CNPlan_ShareRewardWechatClick',
  /** 中文特惠-点击复制促销码 */
  CNPlan_PromoCodeCopyClick: 'CNPlan_PromoCodeCopyClick',
  /** 中文特惠-点击如何使用促销码 */
  CNPlan_PromoGuideClick: 'CNPlan_PromoGuideClick',
  /** 中文特惠-调价通知 Banner -点击查看详情 */
  CNSpecialPricingUpdateBannerDetailsClick:
    'CNSpecialPricingUpdateBannerDetailsClick',
  /** 中文特惠-调价详情弹窗关闭 */
  CNSpecialPricingUpdateModalCloseClick:
    'CNSpecialPricingUpdateModalCloseClick',
} as const;
